import { IconSVG } from '../types';

export const Subtract = ({ size, style }: IconSVG) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      style={style}
      fill="none" 
      viewBox="0 0 18 18">
      <path stroke="currentColor" strokeLinecap="round" strokeWidth="1.4" d="M3.941 9h10" />
    </svg>
  );
};